export default __webpack_public_path__ + "static/media/modernChair.475ad65d.png";